import { render, staticRenderFns } from "./MemberInfoAssetsModal.vue?vue&type=template&id=6027fbbc&"
import script from "./MemberInfoAssetsModal.vue?vue&type=script&lang=js&"
export * from "./MemberInfoAssetsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports